import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfetti = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "scale(0.9412)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M12.0126 15.2081L13.7021 10.1396C14.4681 7.84153 14.8511 6.69252 15.7573 6.47858C16.6636 6.26464 17.52 7.12107 19.2329 8.83392L22.6119 12.2129C24.3247 13.9258 25.1812 14.7822 24.9672 15.6885C24.7533 16.5947 23.6043 16.9777 21.3062 17.7438L16.2377 19.4333C13.4723 20.3551 12.0896 20.816 11.3597 20.0861C10.6298 19.3562 11.0908 17.9735 12.0126 15.2081Z",
					stroke: "white",
					strokeLinecap: "round",
					strokeWidth: 5.5,
					style: { fill: "var(--sticker-pastel,#FFE29A)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.34878 20.4627L7.60143 13.7047C8.62279 10.6406 9.13347 9.10858 10.3418 8.82332C11.5502 8.53807 12.6921 9.67998 14.9759 11.9638L19.4812 16.4691C21.7649 18.7529 22.9069 19.8948 22.6216 21.1032C22.3364 22.3115 20.8044 22.8221 17.7403 23.8436L10.9823 26.0963C7.29512 27.3253 5.45151 27.9399 4.47834 26.9667C3.50516 25.9935 4.1197 24.1499 5.34878 20.4627Z",
					stroke: "white",
					strokeLinecap: "round",
					strokeWidth: 5.5,
					style: { fill: "var(--sticker-pastel,#FFE29A)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.3128 23.9071C16.3128 23.9071 15.302 20.8655 15.302 18.8526C15.302 16.8395 16.3128 13.798 16.3128 13.798M10.7529 25.4234C10.7529 25.4234 9.89913 21.7542 9.74201 19.358C9.4824 15.399 10.7529 9.24902 10.7529 9.24902",
					stroke: "white",
					strokeLinecap: "round",
					strokeWidth: 5.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.3452 12.7871L19.5372 11.8272C19.7309 10.858 20.4293 10.0669 21.3669 9.75437C22.3047 9.44183 23.0029 8.6508 23.1968 7.6816L23.3888 6.72168",
					stroke: "white",
					strokeLinecap: "round",
					strokeWidth: 5.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.4253 17.118L23.7092 17.2819C24.5853 17.7878 25.6869 17.6762 26.4438 17.005C27.1293 16.3971 28.1054 16.243 28.9449 16.61L29.3336 16.7799",
					stroke: "white",
					strokeLinecap: "round",
					strokeWidth: 5.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.0594 3.15137C12.6094 3.88745 12.7221 4.83595 13.3322 5.44599L13.4627 5.5765C13.987 6.10071 14.1802 6.87082 13.9656 7.58046",
					stroke: "white",
					strokeLinecap: "round",
					strokeWidth: 5.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.2504 4.00295L20.2136 4.13243C20.1732 4.27466 20.1531 4.34577 20.1625 4.41558C20.1721 4.48539 20.2104 4.54599 20.2868 4.66721L20.3565 4.77757C20.6256 5.20413 20.7602 5.41739 20.6686 5.59185C20.5768 5.76629 20.3196 5.78637 19.8052 5.82654L19.672 5.83693C19.5259 5.84834 19.4528 5.85405 19.3889 5.88763C19.3249 5.92122 19.2775 5.97889 19.1826 6.09421L19.0961 6.19921C18.762 6.60505 18.5949 6.80797 18.4043 6.78187C18.2137 6.75578 18.1259 6.51795 17.9501 6.0423L17.9047 5.91923C17.8548 5.78407 17.8297 5.71649 17.7807 5.66743C17.7318 5.61838 17.6642 5.59342 17.529 5.54347L17.4059 5.49802C16.9303 5.32229 16.6924 5.23442 16.6663 5.04385C16.6403 4.85327 16.8431 4.68621 17.249 4.35207L17.354 4.26562C17.4694 4.17067 17.5269 4.12321 17.5605 4.0593C17.5941 3.99539 17.5999 3.9223 17.6112 3.77611L17.6216 3.64302C17.6618 3.12857 17.6819 2.87134 17.8563 2.77966C18.0308 2.68797 18.244 2.82254 18.6707 3.09169L18.781 3.16133C18.9022 3.23781 18.9628 3.27605 19.0325 3.28561C19.1024 3.29517 19.1735 3.27495 19.3157 3.23454L19.4452 3.19775C19.9457 3.05554 20.1959 2.98443 20.3299 3.11834C20.4637 3.25225 20.3927 3.50249 20.2504 4.00295Z",
					stroke: "white",
					strokeLinejoin: "round",
					strokeWidth: 5.5,
					style: { fill: "var(--sticker-pastel,#FFE29A)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.9995 9.44629V13.4463M24.9995 11.4463H28.9995",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 5.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.34878 20.4627L7.60143 13.7047C8.62279 10.6406 9.13347 9.10858 10.3418 8.82332C11.5502 8.53807 12.6921 9.67998 14.9759 11.9638L19.4812 16.4691C21.7649 18.7529 22.9069 19.8948 22.6216 21.1032C22.3364 22.3115 20.8044 22.8221 17.7403 23.8436L10.9823 26.0963C7.29512 27.3253 5.45151 27.9399 4.47834 26.9667C3.50516 25.9935 4.1197 24.1499 5.34878 20.4627Z",
					strokeLinecap: "round",
					strokeWidth: 1.5,
					style: {
						fill: "var(--sticker-pastel,#FFE29A)",
						stroke: "var(--sticker-dark,#B87C1F)"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.3128 23.9071C16.3128 23.9071 15.302 20.8655 15.302 18.8526C15.302 16.8395 16.3128 13.798 16.3128 13.798M10.7529 25.4234C10.7529 25.4234 9.89913 21.7542 9.74201 19.358C9.4824 15.399 10.7529 9.24902 10.7529 9.24902",
					strokeLinecap: "round",
					strokeWidth: 1.5,
					style: { stroke: "var(--sticker-accent,#FBC852)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.3452 12.7871L19.5372 11.8272C19.7309 10.858 20.4293 10.0669 21.3669 9.75437C22.3047 9.44183 23.0029 8.6508 23.1968 7.6816L23.3888 6.72168",
					strokeLinecap: "round",
					strokeWidth: 1.5,
					style: { stroke: "var(--sticker-dark,#B87C1F)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.4253 17.118L23.7092 17.2819C24.5853 17.7878 25.6869 17.6762 26.4438 17.005C27.1293 16.3971 28.1054 16.243 28.9449 16.61L29.3336 16.7799",
					strokeLinecap: "round",
					strokeWidth: 1.5,
					style: { stroke: "var(--sticker-dark,#B87C1F)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.0594 3.15137C12.6094 3.88745 12.7221 4.83595 13.3322 5.44599L13.4627 5.5765C13.987 6.10071 14.1802 6.87082 13.9656 7.58046",
					strokeLinecap: "round",
					strokeWidth: 1.5,
					style: { stroke: "var(--sticker-dark,#B87C1F)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.2504 4.00295L20.2136 4.13243C20.1732 4.27466 20.1531 4.34577 20.1625 4.41558C20.1721 4.48539 20.2104 4.54599 20.2868 4.66721L20.3565 4.77757C20.6256 5.20413 20.7602 5.41739 20.6686 5.59185C20.5768 5.76629 20.3196 5.78637 19.8052 5.82654L19.672 5.83693C19.5259 5.84834 19.4528 5.85405 19.3889 5.88763C19.3249 5.92122 19.2775 5.97889 19.1826 6.09421L19.0961 6.19921C18.762 6.60505 18.5949 6.80797 18.4043 6.78187C18.2137 6.75578 18.1259 6.51795 17.9501 6.0423L17.9047 5.91923C17.8548 5.78407 17.8297 5.71649 17.7807 5.66743C17.7318 5.61838 17.6642 5.59342 17.529 5.54347L17.4059 5.49802C16.9303 5.32229 16.6924 5.23442 16.6663 5.04385C16.6403 4.85327 16.8431 4.68621 17.249 4.35207L17.354 4.26562C17.4694 4.17067 17.5269 4.12321 17.5605 4.0593C17.5941 3.99539 17.5999 3.9223 17.6112 3.77611L17.6216 3.64302C17.6618 3.12857 17.6819 2.87134 17.8563 2.77966C18.0308 2.68797 18.244 2.82254 18.6707 3.09169L18.781 3.16133C18.9022 3.23781 18.9628 3.27605 19.0325 3.28561C19.1024 3.29517 19.1735 3.27495 19.3157 3.23454L19.4452 3.19775C19.9457 3.05554 20.1959 2.98443 20.3299 3.11834C20.4637 3.25225 20.3927 3.50249 20.2504 4.00295Z",
					strokeLinejoin: "round",
					strokeWidth: 1.5,
					style: {
						fill: "var(--sticker-pastel,#FFE29A)",
						stroke: "var(--sticker-dark,#B87C1F)"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.9995 9.44629V13.4463M24.9995 11.4463H28.9995",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5,
					style: { stroke: "var(--sticker-dark,#B87C1F)" }
				})
			]
		})
	});
};
export default SvgConfetti;
